export default __webpack_public_path__ + "static/media/calender.c97fbc9d.svg";